export default "__VITE_ASSET__b7c7f547__"